import { Box, Spinner, Text, useColorModeValue } from '@chakra-ui/react'
import { motion } from 'framer-motion'

interface ButtonBadgeProps {
  onClickHandle: () => void
  text: string
  isLoading: boolean
  wide?: boolean
}

export default function ButtonBadge({
  onClickHandle,
  text,
  isLoading,
  wide = true,
}: ButtonBadgeProps) {
  const badgeStyles = {
    py: 2,
    //px: { base: 10, xl: 16 },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    bg: useColorModeValue('primary.base', 'rgba(155, 81, 244, 0.3)'),
    px: 6,
    whileHover: { scale: 1.1 },
    whileTap: { scale: 0.9 },
    minHeight: wide ? 30 : 100,
    width: wide ? { lg: 450, base: 200 } : 300,
  }

  return (
    <Box p={wide ? { base: 4, xl: 8 } : 0}>
      <Box as={motion.div} marginY={4} {...badgeStyles} onClick={onClickHandle} cursor="pointer">
        {isLoading && <Spinner mr={4} color="white" />}
        <Text bg="secondary" whiteSpace="nowrap">
          {text}
        </Text>
      </Box>
    </Box>
  )
}
